import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var DocumentCategoryTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(DocumentCategoryTransformer, _BaseTransformer);
  var _super = _createSuper(DocumentCategoryTransformer);
  function DocumentCategoryTransformer() {
    _classCallCheck(this, DocumentCategoryTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(DocumentCategoryTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        parentCategory: data.parent_category,
        categoryName: data.category_name,
        recordOwner: data.recordOwner,
        createdBy: data.created_by,
        createdOn: data.created_on,
        lastModifiedOn: data.last_modified_on,
        lastModifiedBy: data.last_modified_by,
        recordId: data.record_id
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return DocumentCategoryTransformer;
}(BaseTransformer);